import type { HttpInterceptorFn } from '@angular/common/http';
import { ApiEndpoints } from '@shared/common/apiPoint';

export const blobInterceptor: HttpInterceptorFn = (req, next) => {
  const hasFileResponse = [
    'card/export-chart',
    'card/get-rout-schdule-actul-paid-export',
    'card/get-paid-routed-time-header-export',
    'card/get-overtime-header-export',
    'card/get-deadhead-header-export',
    'card/get-time-monitoring-export',
    'card/get-time-trending-export',
    'card/export-overtime-drilldown',
    'card/export-paid-routed-time-drilldown',
    'card/export-routed-time-drilldown',
    'card/export-time-monitoring-drill-down-workday',
    'card/export-time-monitoring-drill-down-workday-by-teCurve',
    'card/export-route-schedule-actual-paid-drill-down',
    ApiEndpoints.BICard.get_schedule_vs_actual_export,
    ApiEndpoints.BICard.byte_curve_statistics_export,
  ].some(url => req.url.includes(url));
  if (hasFileResponse) {
    req = req.clone({
      responseType: 'blob' as 'json',
    });
  }
  return next(req);
};
